import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[paceCoreTextInputRestriction]',
    standalone: false,
    host: {
        '(keydown)': 'onKeyDown($event)',
    },
})
export class TextInputRestrictionDirective {
    public constructor(private el: ElementRef) {}

    public onKeyDown(event: KeyboardEvent): void {
        const nativeEl = <HTMLInputElement>this.el.nativeElement;
        if (nativeEl.selectionStart === 0 && event.code === 'Space') {
            event.preventDefault();
        }
    }
}
